import { FilterType } from "./enum/filter-type";
import { DatasetCollection } from "./enum/dataset-collection";
import { WidgetType } from "./enum/widget-types";
import { BarSettings } from "./widget-settings/bar-settings";
import { CardSettings } from "./widget-settings/card-settings";
import { LineSettings } from "./widget-settings/line-settings";
import { PieSettings } from "./widget-settings/pie-settings";
import { TableSettings } from "./widget-settings/table-settings";

export class Dashboard {
  id!: string;
  name!: string;
  dataset!: Dataset;
  widgets!: Widget[];
  filters!: Filter[];
  settings?: Settings;
}

export class Widget {
  id!: string;
  name: string = "";
  type: WidgetType = WidgetType.Card;
  position: Position = new Position();
  settings!: string;
  value: any;

  get parsedSettings() {
    const value = JSON.parse(this.settings);

    switch (this.type) {
      case WidgetType.Card:
        return Object.assign(new CardSettings(), value);
      case WidgetType.Line:
        return Object.assign(new LineSettings(), value);
      case WidgetType.Pie:
        return Object.assign(new PieSettings(), value);;
      case WidgetType.Bar:
        return Object.assign(new BarSettings(), value);
      case WidgetType.Table:
        return Object.assign(new TableSettings(), value);
      default:
        return undefined;
    }
  }
}

export class Position {
  x: number = 0;
  y: number = 0;
  w: number = 0;
  h: number = 0;
}

export class Filter {
  id!: string;
  name!: string;
  customOptions!: boolean;
  options!: any;
  field!: string;
  type!: FilterType;
  multiValue!: boolean;
  customInitialValue!: boolean;
  initialValue!: any;
  filterValue!: FilterValue;
}

export class FilterValue {
  options: FilterOption[] = [];
  value!: any;
}

export class FilterOption {
  label!: string;
  value!: string;
}

export class Dataset {
  id: string = "";
  name: string = "";
  collection!: DatasetCollection;
  query: string = "";
  fields: string[] = [];
  filters: string[] = [];
}

export class Settings {
  favorite!: boolean;
}
